import React from 'react';

interface ErrorIconProps {
  width?: number;
  height?: number;
  color?: string;
}

const ErrorIcon: React.FC<ErrorIconProps> = ({ 
  width = 24, 
  height = 24, 
  color = "#C34922" 
}) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M12.4951 1.49494L22.5051 11.505C22.7785 11.7784 22.7785 12.2216 22.5051 12.4949L12.4951 22.505C12.2217 22.7784 11.7785 22.7784 11.5051 22.505L1.49506 12.4949C1.2217 12.2216 1.2217 11.7784 1.49506 11.505L11.5051 1.49494C11.7785 1.22158 12.2217 1.22157 12.4951 1.49494Z" 
        fill={color}
      />
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M12 7.25C12.4142 7.25 12.75 7.58579 12.75 8V13C12.75 13.4142 12.4142 13.75 12 13.75C11.5858 13.75 11.25 13.4142 11.25 13V8C11.25 7.58579 11.5858 7.25 12 7.25ZM12 15.75C12.4142 15.75 12.75 16.0858 12.75 16.5V16.6111C12.75 17.0253 12.4142 17.3611 12 17.3611C11.5858 17.3611 11.25 17.0253 11.25 16.6111V16.5C11.25 16.0858 11.5858 15.75 12 15.75Z" 
        fill="white"
      />
    </svg>
  );
};

export default ErrorIcon;

